import getAccessToken from '~/middleware/auth-utils/getAccessToken'
import saveDestinationURL from '~/middleware/auth-utils/saveDestinationURL'
import redirectToDestinationURL from '~/middleware/auth-utils/redirectToDestinationURL'
import silentlyAuthenticateWithAuth0 from '~/middleware/auth-utils/silentlyAuthenticateWithAuth0'

export default defineNuxtRouteMiddleware(async(to, _from) => {
  const {
    $auth,
    $bugsnag,
    $store,
    $urql,
  } = useNuxtApp()

  const router = useRouter()

  // Any time a user visits the /unauthenticate route, the homepage is saved as the destination URL, and they are redirected to the Auth0 login page.
  if (to?.path === '/unauthenticate') {
    saveDestinationURL({ fullPath: '/' })

    // Send user to Auth0 login page
    $auth.authorize({ prompt: 'login' })
    return
  }

  try {
    const isAuthenticated = await $urql.isAuthenticated()
    if (isAuthenticated) {
      await $store.dispatch('self/requestSelf')
      return
    }

    // This determines if the user entered the app from the Auth0 login page by checking if the current route contains the Auth0 hash
    if (to?.hash) {
      const accessToken = await getAccessToken($auth)

      // Sets an access token cookie containing the Auth0 access token that is used for authentication
      await $urql.login(accessToken)

      redirectToDestinationURL(router)

      return
    }

    const silentAccessToken = await silentlyAuthenticateWithAuth0($auth, $bugsnag)

    if (silentAccessToken) {
      // Sets an access token cookie containing the Auth0 access token that is used for authentication
      await $urql.login(silentAccessToken)

      await $store.dispatch('self/requestSelf')
      return
    }

    saveDestinationURL(to)

    // Send user to Auth0 login page
    $auth.authorize({ prompt: 'login' })
  } catch (error) {
    $bugsnag.notify(error)

    return navigateTo('/')
  }
})
